var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLikedComment = function SvgLikedComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95959A",
    stroke: "#95959A",
    strokeWidth: 1.5,
    d: "M8.081 13.207a7.5 7.5 0 0 1-.06.032l-.015.008-.002.001-.002.001H8L8 13.25l-.002-.001h-.002l-.002-.002-.015-.008a12.785 12.785 0 0 1-.29-.16l-.37.653.37-.653a21.293 21.293 0 0 1-3.313-2.328C2.561 9.19.749 7.002.749 4.5a3.75 3.75 0 0 1 6.667-2.357L8 2.864l.583-.72A3.75 3.75 0 0 1 15.25 4.5c0 2.5-1.812 4.688-3.625 6.25a21.297 21.297 0 0 1-3.313 2.328l.369.653-.37-.653-.23.128Zm0 0 .357.66m-.357-.66.357.66m0 0a7.472 7.472 0 0 1-.067.035m.067-.035-.067.035m0 0-.019.01.019-.01Z"
  })));
};
export default SvgLikedComment;